import { isBoolean } from 'lodash';
import { useState } from 'react';

export const useEditGlobalSettingsPage = () => {
  const [showPublicationModal, setShowPublicationModal] = useState(false);
  const [showSyncLocationsModal, setShowSyncLocationsModal] = useState(false);

  return {
    showPublicationModal,
    showSyncLocationsModal,
    onTogglePublicationModal: (active?: boolean) =>
      setShowPublicationModal((state) => (isBoolean(active) ? active : !state)),
    onToggleSyncLocationsModal: (active?: boolean) =>
      setShowSyncLocationsModal((state) =>
        isBoolean(active) ? active : !state,
      ),
  };
};
